<template>
  <div v-if="visible" class="ia-banner col-12">
    <div class="banner-content">
      <div class="banner-header">
        <div class="text-h5 text-weight-bold text-white">
          Informações importantes sobre o uso da IA
        </div>
        <q-btn
          color="white"
          text-color="primary"
          label="Entendi"
          @click="handleClose"
        />
      </div>
      <div class="banner-body">
        <p>
          <b
            >Bem-vindo ao nosso assistente virtual, leia as instruções a seguir
            com atenção e clique em ENTENDI para seguir!</b
          >
        </p>
        <ul>
          <li>
            Seus dados NÃO são utilizados para treinamento desse assistente
          </li>
          <li>
            O assistente NÃO pode executar nenhuma ação em seu nome, apenas
            fornece informações e respostas baseadas em suas perguntas
          </li>
          <li>
            O assistente tem acesso somente aos mesmos dados que você teria nos
            relatórios, porém, ele pode te ajudar e consolidar e resumir eles de
            maneira mais ágil
          </li>
          <li>
            As respostas são geradas automaticamente e podem requerer
            verificação
          </li>
          <li>
            Seus dados são processados de acordo com nossa política de
            privacidade
          </li>
          <li>Para melhor experiência, faça perguntas claras e específicas</li>
          <li>
            Em caso de dúvidas, críticas ou sugestões, entre em contato com
            suporte
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "IABanner",
  props: {
    visible: {
      type: Boolean,
      default: true,
    },
  },
  emits: ["close"],
  methods: {
    handleClose() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
/* Banner IA styles */
.ia-banner {
  max-width: 1200px;
  width: 100%;
  margin: 0 auto 20px;
  background: linear-gradient(135deg, #1976d2, #213864);
  border-radius: 10px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  animation: fadeIn 0.5s ease-in-out;
}

.banner-content {
  padding: 0;
}

.banner-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  background-color: rgba(0, 0, 0, 0.1);
  gap: 15px;
}

.banner-body {
  padding: 15px 20px;
  color: white;
}

.banner-body p,
.banner-body ul {
  margin: 10px 0;
}

.banner-body ul {
  padding-left: 20px;
}

.banner-body li {
  margin: 8px 0;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 1211px) {
  .ia-banner {
    max-width: 95%;
    width: 95%;
  }
}

@media (max-width: 838px) {
  .ia-banner {
    max-width: 98%;
    width: 98%;
  }
}

@media (max-width: 300px) {
  .ia-banner {
    max-width: 100%;
    width: 100%;
  }
}
</style>
